module.exports = __webpack_public_path__ + "static/media/lucina_0.41f21336.png";